module.exports = __webpack_public_path__ + "img/prize_title.2c964890.png";